import { graphql } from '@/gql'

export const CreateJobCandidateMutation = graphql(/* GraphQL */ `
  mutation createJobCandidateMutation($input: CreateJobCandidateInput!) {
    createJobCandidate(input: $input) {
      id
    }
  }
`)

export const UpdateJobCandidatePreferredMutation = graphql(/* GraphQL */ `
  mutation updateJobCandidatePreferred($input: UpdateJobCandidatePreferredInput!) {
    updateJobCandidatePreferred(input: $input) {
      id
      isPreferred
    }
  }
`)

export const UpdateJobCandidateStatusMutation = graphql(/* GraphQL */ `
  mutation updateJobCandidateStatus($input: UpdateJobCandidateStatusInput!) {
    updateJobCandidateStatus(input: $input) {
      id
    }
  }
`)

export const UpdateJobCandidateStepMutation = graphql(/* GraphQL */ `
  mutation updateJobCandidateStep($input: UpdateJobCandidateStepInput!) {
    updateJobCandidateStep(input: $input) {
      id
      step
    }
  }
`)

export const ShareCandidatesWithPartnerMutation = graphql(/* GraphQL */ `
  mutation shareCandidatesWithPartner($input: ShareCandidatesWithPartnerInput!) {
    shareCandidatesWithPartner(input: $input) {
      id
    }
  }
`)

export const ForwardCandidateMutation = graphql(/* GraphQL */ `
  mutation forwardCandidate($input: ForwardCandidateInput!) {
    forwardCandidate(input: $input) {
      id
      step
      sourceCandidate {
        id
        step
        presentedToClient
        stageHistory {
          stage
          changedByName
          createdAt
        }
        bid {
          id
          rate
          fees {
            id
            feeType
            application
            basis
            rate
          }
        }
      }
    }
  }
`)

export const WithdrawForwardedCandidateMutation = graphql(/* GraphQL */ `
  mutation withdrawForwardedCandidate($input: WithdrawForwardedCandidateInput!) {
    withdrawForwardedCandidate(input: $input) {
      id
      step
      presentedToClient
    }
  }
`)

export const InviteCandidateToOnboardMutation = graphql(/* GraphQL */ `
  mutation inviteCandidateToOnboard($input: InviteCandidateToOnboardInput!) {
    inviteCandidateToOnboard(input: $input) {
      id
      step
      stageHistory {
        stage
        changedByName
        createdAt
      }
      hire {
        id
        activeStatus
      }
    }
  }
`)

export const WithdrawJobCandidateMutation = graphql(/* GraphQL */ `
  mutation withdrawJobCandidate($input: WithdrawJobCandidateInput!) {
    withdrawJobCandidate(input: $input) {
      id
      step
      viewerCanWithdraw
      stageHistory {
        stage
        changedByName
        createdAt
      }
    }
  }
`)
